import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
} from 'react-bootstrap';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import { Materials } from '../../constants';
import { getWorkTypeNameById } from '../../utils';

class PublicationOtherMaterials extends Component {
  handleCheck(e, field, key) {
    const { fields } = this.props;
    const materials = fields[field] || {};

    materials[key] = e.target.checked;
    this.props.assignAttribute(field, { ...materials });
  }

  handleText(e, field, key) {
    const { fields } = this.props;
    const materials = fields[field] || {};

    materials[key] = e.target.value;
    this.props.assignAttribute(field, { ...materials });
  }

  handleNext() {
    // const { fields } = this.props;

    this.props.hideAlert();
    let checked = true;

    if (checked) {
      this.props.router.push('/publication-reg/authorized-agent');
    } else {
      this.props.alert('error', 'Please check the required fields.');
    }
  }

  render() {
    const { fields, workTypes } = this.props;
    const typeName = getWorkTypeNameById(fields.type, workTypes);
    const materials = Materials[typeName];
    const materialsExcluded = fields.materialsExcluded || {};
    const materialsIncluded = fields.materialsIncluded || {};
    const previousRegistration = fields.previousRegistration || {};

    return (
      <div className="materials">
        <Heading text="We Need To Gather More Information About Your Registration" />
        <div className="content">
          <p>
            Please help us identify the parts of your registration that were
            previously copyrighted, not created by the authors you listed,
            and/or that are cover songs.
          </p>
          <p>&nbsp;</p>
          <Form>
            <Row>
              <Col sm={4}>
                <p>
                  <b>
                    What parts of your registration were NOT created by the
                    authors:
                  </b>
                </p>
                {materials.Excluded.map((material, i) => (
                  <FormGroup key={i}>
                    <Checkbox
                      checked={materialsExcluded[material] === true}
                      onChange={(e) =>
                        this.handleCheck(e, 'materialsExcluded', material)
                      }
                    >
                      {material}
                    </Checkbox>
                  </FormGroup>
                ))}
                <FormGroup>
                  <ControlLabel>Titles </ControlLabel>
                  <FormControl
                    componentClass="textarea"
                    className="inline"
                    value={materialsExcluded['Other'] || ''}
                    placeholder='Example:&#13;&#10;"Title 1" is a cover song&#13;&#10;"Title 2" contains an excerpt from "Poem X"'
                    onChange={(e) =>
                      this.handleText(e, 'materialsExcluded', 'Other')
                    }
                  />
                </FormGroup>
              </Col>

              <Col sm={4} className="section-divider">
                <p>
                  <b>
                    If your registration contains previously registered content,
                    provide the registration number(s) below if you have it.
                  </b>
                </p>
                <FormGroup>
                  <ControlLabel>First Previous Registration #: </ControlLabel>
                  <FormControl
                    type="text"
                    className="inline"
                    value={previousRegistration.firstNumber || ''}
                    onChange={(e) =>
                      this.handleText(e, 'previousRegistration', 'firstNumber')
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Year: </ControlLabel>
                  <FormControl
                    type="text"
                    className="inline"
                    value={previousRegistration.firstYear || ''}
                    onChange={(e) =>
                      this.handleText(e, 'previousRegistration', 'firstYear')
                    }
                  />
                </FormGroup>
                <p>&nbsp;</p>
                <FormGroup>
                  <ControlLabel>Second Previous Registration #: </ControlLabel>
                  <FormControl
                    type="text"
                    className="inline"
                    value={previousRegistration.secondNumber || ''}
                    onChange={(e) =>
                      this.handleText(e, 'previousRegistration', 'secondNumber')
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>Year: </ControlLabel>
                  <FormControl
                    type="text"
                    className="inline"
                    value={previousRegistration.secondYear || ''}
                    onChange={(e) =>
                      this.handleText(e, 'previousRegistration', 'secondYear')
                    }
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <p>
                  <b>
                    What parts of your registration were created by the authors?
                  </b>
                </p>
                {materials.Included.map((material, i) => (
                  <FormGroup key={i}>
                    <Checkbox
                      checked={materialsIncluded[material] === true}
                      onChange={(e) =>
                        this.handleCheck(e, 'materialsIncluded', material)
                      }
                    >
                      {material}
                    </Checkbox>
                  </FormGroup>
                ))}
                <FormGroup>
                  <ControlLabel>Titles </ControlLabel>
                  <FormControl
                    componentClass="textarea"
                    className="inline"
                    value={materialsIncluded['Other'] || ''}
                    placeholder='Example:&#13;&#10;"Title 1" just the sound recording&#13;&#10;"Title 2" all materials'
                    onChange={(e) =>
                      this.handleText(e, 'materialsIncluded', 'Other')
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </div>

        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.goBack()}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
  workTypes: state.global.workTypes,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicationOtherMaterials);



// WEBPACK FOOTER //
// src/components/Publication/PublicationOtherMaterials.jsx